import { render, staticRenderFns } from "./PremiumWindow.vue?vue&type=template&id=cf018dda&"
import script from "./PremiumWindow.vue?vue&type=script&lang=js&"
export * from "./PremiumWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports